import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useCreatePlaylist = ({ onSuccess }) => {
  const { response: createdPlaylist, onSubmit: handleSubmit } = useFetch(
    'create-playlist',
    Api.PLAYLIST_CREATE
  );

  const onSubmit = (values) => handleSubmit({ body: values, onSuccess });

  return {
    onSubmit,
  };
};

export default useCreatePlaylist;
